
let lTime = undefined
let loadprogress = 0
let times = [] 

let dlamts = []
let dltimes = []

function average(array) {
    return array.reduce((a, b) => a + b) / array.length;
}

function watch(ep) {
    const epurl = window.series.episodes[ep].url
    console.log(epurl)
    console.log("reseting player")
    reset()
    console.log("creating video.js")
    const vid = videojs(gebi("player"), {}, () => {
        console.log("videojs ready")
        vid.pause()
        vid.currentTime(0)
        vid.src({
            src: epurl,
            type: 'video/mp4',
        })
        vid.load()
        vid.on("progress", () => {
            if (lTime == undefined) {
                lTime = Date.now()
                return
            }
            let now = Date.now()
            const between = now-lTime
            dltimes.push(between)
            const buf = vid.tech_.el_.buffered
            let prog = getBuffer(buf, vid.currentTime())
            const amtloaded = prog-loadprogress
            dlamts.push(amtloaded)
            loadprogress = prog
            //console.log(amtloaded, between)
            const secs = between/1000
            times.push(amtloaded/secs)
            scon("cachedamt",(prog - vid.currentTime()).toFixed(2))
            let avg = average(times).toFixed(2)
            if (isNaN(avg)) {
                avg = 0 
                times = []
            }
            scon("speed",average(times).toFixed(2))
            if (times.length > 5) {
                times = times.slice(1)
            } 
            lTime = now
            scon("avgdl",average(dlamts).toFixed(2))
            if (dlamts.length > 5) {
                dlamts = dlamts.slice(1)
            }
            scon("avgtime",average(dltimes).toFixed(2))
            if (dltimes.length > 5) {
                dltimes = dltimes.slice(1)
            } 
        })
        vid.on("timeupdate", () => {
            const buf = vid.tech_.el_.buffered
            let prog = getBuffer(buf, vid.currentTime())
            scon("cachedamt",(prog - vid.currentTime()).toFixed(2))
        })
    })
}

function getBuffer(buf, ctime) {
    try {
        for (var i = 0; i < buf.length; i++) {
            if (buf.start(buf.length - 1 - i) < ctime) {
                return buf.end(buf.length - 1 - i) - ctime
            }
        }
    } catch {
        return 0
    }
    return 0
}

function getIndexFromEpisode(ep) {
    for (const epd in window.series.episodes) {
        if (window.series.episodes[epd].number == ep) {
            return epd
        }
    }
    throw new Error("Unknown episode: "+ep)
}

function select(ep) {
    [...document.getElementsByClassName("selected-page")].forEach(s => {
        s.className = "unselected-page"
    })
    gebi("ep"+ep).className = "selected-page"
    watch(getIndexFromEpisode(ep))
}

function next() {
    const old = [...document.getElementsByClassName("selected-page")][0]
    const next = parseInt(old.innerHTML)+1
    if (next > window.series.episodes.length) {
        return
    }
    select(next)
}

function prev() {
    const old = [...document.getElementsByClassName("selected-page")][0]
    const next = parseInt(old.innerHTML)-1
    if (next < 1) {
        return
    }
    select(next)
}

function reCreateVideo() {
    var container = gebi("vidcontainer")
    console.log("clearing children")
    while (container.firstChild) {
        container.removeChild(container.lastChild);
        console.log("child removed")
    }
    console.log("creating element")
    var newvid = document.createElement("video")
    // id="player", class="video-js" controls=true, height=480, width="auto", preload='auto'
    const attr = {
        id: "player",
        class: "video-js",
        controls: true,
        height: 480,
        width: "auto",
        preload: "auto"
    }
    console.log("settings attrs")
    setAttributes(newvid, attr);
    console.log("appending element")
    container.appendChild(newvid)
}

function reset() {
    console.log("re creating video node")
    reCreateVideo();
    console.log("reseting stats")
    dlamts = []
    dltimes = []
    lTime = undefined
    loadprogress = 0
    times = []
    console.log("clearing ui")
    scon("cachedamt","-")
    scon("speed","-")
    scon("avgdl","-")
    scon("avgtime","-")
}

function setAttributes(el, attrs) {
  for(var key in attrs) {
      console.log("set '" + key + "' to '"+attrs[key]+"'")
      el.setAttribute(key, attrs[key]);
  }
}

window.next = next
window.prev = prev
//window.select = select

function gebi(i) {
    return document.getElementById(i)
}
function scon(i,v) {
    gebi(i).innerText = v
}

function createepsel(episodenum) {
    const g = document.createElement("a")
    setAttributes(g, {"class": "unselected-page", "id": "ep"+episodenum})
    g.innerText = episodenum
    g.addEventListener("click", () => {
        select(episodenum)
    })
    const contain = document.createElement("li")
    contain.appendChild(g)
    const pages = gebi("pages")
    pages.insertBefore(contain, pages.lastChild)
}

async function init() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
    if (!params.s) {
        window.location = "/"
    }
    const show = params.s;
    const s = await fetch("/show/"+show)
    if (s.status != 200) {
        throw new Error("Server returned "+s.status)
    }
    const cutg = await s.json();
    window.series = cutg
    scon("title",cutg.title)
    scon("ltitle",cutg.title)
    scon("ldesc",cutg.description)
    scon("source",cutg.sourcefrom)
    for (const epid in cutg.episodes) {
        console.log("Creating episode "+epid)
        createepsel(cutg.episodes[epid].number)
    }
    

}
scon("loading","Loading show info...")
init().then(() => {
    scon("loading", "Launching...")
    select(series.episodes[0].number)
})
